import NotificationFeed from './NotificationFeed'

export default {
  NotificationFeed
}
